import type { BuxusOperatorPayload, OperatorMapLegendItem } from '@buxus/shared'
import { formatPhoneDisplay } from '@buxus/shared'
import type { PersistedOperatorEntry } from '../../platform/buxus/OperatorSessionContext'

export type HomeOperatorCatalogEntry = {
  operatorId: string
  name: string
  cachedVersion: string
  legendItems: readonly OperatorMapLegendItem[]
}

export type OperatorMapPreviewField = {
  label: string
  value: string
}

export type OperatorMapPreviewSnapshot = {
  operatorId: string
  name: string
  fields: OperatorMapPreviewField[]
}

function str(v: unknown): string {
  return typeof v === 'string' ? v.trim() : ''
}

export function buildHomeOperatorCatalogEntry(
  op: PersistedOperatorEntry,
  legendItems: readonly OperatorMapLegendItem[],
): HomeOperatorCatalogEntry {
  return {
    operatorId: op.operatorId,
    name: op.name,
    cachedVersion: op.cachedVersion,
    legendItems,
  }
}

/** Operator summary fields for the Home map preview card. */
export function buildOperatorMapPreviewSnapshot(
  op: PersistedOperatorEntry,
  payload: BuxusOperatorPayload | null,
): OperatorMapPreviewSnapshot {
  const operator = payload?.operator
  const fields: OperatorMapPreviewField[] = []

  const push = (label: string, value: string | undefined | null) => {
    const v = value?.trim()
    if (v) fields.push({ label, value: v })
  }

  const pushPhone = (label: string, value: string | undefined | null) => {
    const v = value?.trim()
    if (v) fields.push({ label, value: formatPhoneDisplay(v) })
  }

  pushPhone('Phone', operator?.phoneNumber)
  pushPhone('Emergency', operator?.emergencyNumber)
  push('Email', operator?.email)

  const cityZip = [operator?.city, operator?.zip].map(str).filter(Boolean).join(', ')
  const addressParts = [operator?.addressLine1, operator?.addressLine2, cityZip || null]
    .map(str)
    .filter(Boolean)
  if (addressParts.length) push('Address', addressParts.join(' · '))

  push('Website', operator?.website)

  return {
    operatorId: op.operatorId,
    name: op.name,
    fields,
  }
}
